import List from "./List.js";
import Show from "./Show.js";
import Create from "./Create.js";
import Edit from "./Edit.js";

export default { List, Show, Create, Edit };
